import { useTranslation } from 'react-i18next';
import { GenericResult } from 'components';
import SubmittedSuccessIcon from 'assets/images/enquiry-submitted-icon.svg';

const SendInboxMessageSuccessPage = () => {
  const { t } = useTranslation();

  return (
    <GenericResult
      icon={<img src={SubmittedSuccessIcon} />}
      title={t('admin.sendInboxMessage.sendSuccessTitle')}
      subTitle={t('admin.sendInboxMessage.sendSuccessSubTitle')}
    />
  );
};

export default SendInboxMessageSuccessPage;
